/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";
import { Redirect } from "react-router-dom";
import { Container, Divider, Message, Transition } from "semantic-ui-react";
import Categories from "../../pages/Categories";
import Home from "../../pages/Home";
import { $SERVER, COLOR_1755, COLOR_ACARCIARA } from "../../_const/_const";
import AddEventModal from "../Medium/Modals/AddEvent";
import AddProductModal from "../Medium/Modals/AddProduct";
import EditProductModal from "../Medium/Modals/EditProduct";
import ImageModal from "../Medium/Modals/ImageModal";
import Login from "../Medium/Modals/Login";
import UpdateImageModal from "../Medium/Modals/UpdateImageModal";
import AdminCategories from "../../pages/Admin/Categories";
import AdminStats from "../../pages/Admin/Stats";
import EditCategoryModal from "../Medium/Modals/EditCategory";
import AddCategoryModal from "../Medium/Modals/AddCategory";
import CategoriesSidebar from "../Small/CategoriesSidebar";
import Copyright from "../Small/Copyright";
import GenderPrompt from "../Small/GenderPrompt";
import Loader from "../Small/Loader";
import TopAppBar from "../Small/TopAppBar";
import "./App.css";
import { isBefore18h } from "../../datas/utils";
import { readStoredSession } from "../../services/auth";
import useVisitPing from "../../hooks/useVisitPing";

const App = () => {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [activeMenu, setActiveMenu] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [user, setUser] = useState(() => {
    const session = readStoredSession();
    return session?.role || "";
  });
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openAddProductModal, setOpenAddProductModal] = useState(false);
  const [openEditProductModal, setOpenEditProductModal] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [openUpdateImageModal, setOpenUpdateImageModal] = useState(false);
  const [openAddEventModal, setOpenAddEventModal] = useState(false);
  const [openEditEventModal, setOpenEditEventModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [appMessage, setAppMessage] = useState({});
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState({});
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [eventLoading, setEventLoading] = useState(false);
  const [productsVersion, setProductsVersion] = useState(0);
  const [openEditCategoryModal, setOpenEditCategoryModal] = useState(false);
  const [openAddCategoryModal, setOpenAddCategoryModal] = useState(false);
  const [editCategoryTarget, setEditCategoryTarget] = useState(null);
  const [addCategoryParent, setAddCategoryParent] = useState(null);

  useVisitPing();

  useEffect(() => {
    const backgroundColor = COLOR_1755;
    document.body.style.background = backgroundColor;

    const elementsToUpdate = [
      ".ui.segment",
      ".App",
      ".loader",
      ".categories",
      ".topappbar",
    ];

    elementsToUpdate.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        element.style.backgroundColor = backgroundColor;
      });
    });
  });

  useEffect(() => {
    if (Object.keys(appMessage).length !== 0) {
      setTimeout(() => {
        setAppMessage({});
      }, 5000);
    }
  }, [appMessage]);
  useEffect(() => {
    setEventLoading(true);
    axios
      .get(`${$SERVER}/api/events/getEvent`)
      .then((response) => {
        if (response) {
          setEvent(response.data.data);
        }
      })
      .catch((error) => {
        setAppMessage({
          success: false,
          message: "Il y a eu un probléme, veuillez recharger la page",
        });
      })
      .finally(() => setEventLoading(false));
  }, []);

  return (
    <div className="App" style={{ position: "relative" }}>
      <>
        <Transition
          animation="jiggle"
          duration={500}
          visible={Object.keys(appMessage).length > 0}
        >
          <Message
            style={{
              position: "fixed",
              top: 15,
              zIndex: "1000",
              width: "100%",
            }}
            hidden={Object.keys(appMessage).length === 0}
            success={appMessage.success ? true : false}
            error={!appMessage.success ? true : false}
          >
            {appMessage.message}
          </Message>
        </Transition>
        <CategoriesSidebar
          user={user}
          sidebarVisible={sidebarVisible}
          setSidebarVisible={setSidebarVisible}
          setSelectedCategory={setSelectedCategory}
        >
          <TopAppBar
            setSelectedCategory={setSelectedCategory}
            loading={loading}
            user={user}
            setSidebarVisible={setSidebarVisible}
            setOpenLoginModal={setOpenLoginModal}
          />
          <Divider hidden />
          <Login
            user={user}
            setUser={setUser}
            openLoginModal={openLoginModal}
            setOpenLoginModal={setOpenLoginModal}
            setAppMessage={setAppMessage}
          />
          <GenderPrompt />
          <Switch>
            <Route exact path="/">
              <AddEventModal
                setEvent={setEvent}
                setAppMessage={setAppMessage}
                setOpenLoginModal={setOpenLoginModal}
                openAddEventModal={openAddEventModal}
                setOpenAddEventModal={setOpenAddEventModal}
              />
              <Home
                user={user}
                event={event}
                setEvent={setEvent}
                setOpenLoginModal={setOpenLoginModal}
                setOpenAddEventModal={setOpenAddEventModal}
                setOpenEditEventModal={setOpenEditEventModal}
              />
            </Route>
            <Route path="/categories/:categorie">
              <AddProductModal
                setProductsVersion={setProductsVersion}
                selectedCategory={selectedCategory}
                setOpenLoginModal={setOpenLoginModal}
                setAppMessage={setAppMessage}
                openAddProductModal={openAddProductModal}
                setOpenAddProductModal={setOpenAddProductModal}
              />
              <EditProductModal
                product={selectedProduct}
                setOpenEditProductModal={setOpenEditProductModal}
                setAppMessage={setAppMessage}
                setOpenLoginModal={setOpenLoginModal}
                openEditProductModal={openEditProductModal}
                setProductsVersion={setProductsVersion}
              />
              <UpdateImageModal
                openUpdateImageModal={openUpdateImageModal}
                setOpenUpdateImageModal={setOpenUpdateImageModal}
                setProductsVersion={setProductsVersion}
                product={selectedProduct}
                setOpenLoginModal={setOpenLoginModal}
                setAppMessage={setAppMessage}
              />
              <ImageModal
                openImageModal={openImageModal}
                setOpenImageModal={setOpenImageModal}
                product={selectedProduct}
              />
              <Categories
                filteredProducts={filteredProducts}
                setFilteredProducts={setFilteredProducts}
                productsVersion={productsVersion}
                user={user}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
                dropdownValue={dropdownValue}
                setDropdownValue={setDropdownValue}
                setOpenLoginModal={setOpenLoginModal}
                setOpenAddProductModal={setOpenAddProductModal}
                setOpenImageModal={setOpenImageModal}
                setOpenUpdateImageModal={setOpenUpdateImageModal}
                setOpenEditProductModal={setOpenEditProductModal}
                setSelectedProduct={setSelectedProduct}
              />
            </Route>
            <Route path="/admin/categories">
              {user ? (
                <>
                  <AdminCategories
                    setAppMessage={setAppMessage}
                    setOpenEditModal={setOpenEditCategoryModal}
                    setEditTarget={setEditCategoryTarget}
                    setOpenCreateModal={setOpenAddCategoryModal}
                    setCreateParent={setAddCategoryParent}
                  />
                  <EditCategoryModal
                    open={openEditCategoryModal}
                    onClose={() => setOpenEditCategoryModal(false)}
                    target={editCategoryTarget}
                    setAppMessage={setAppMessage}
                  />
                  <AddCategoryModal
                    open={openAddCategoryModal}
                    onClose={() => setOpenAddCategoryModal(false)}
                    parentId={addCategoryParent}
                    setAppMessage={setAppMessage}
                  />
                </>
              ) : (
                <Redirect to="/" />
              )}
            </Route>
            <Route path="/admin/stats">
              {user ? <AdminStats /> : <Redirect to="/" />}
            </Route>
            <Route path="/confidentialite-de-lapp">
              <Container
                style={{
                  color: "white",
                  fontSize: "1.5em",
                  textAlign: "center",
                  lineHeight: "1.5em",
                }}
              >
                <h2>Engagement de confidentialité</h2>
                La protection de vos données est importante pour le Baravin1755
                Le présent engagement de confidentialité s’applique à la façon
                dont nous collectons, utilisons, divulguons, transférons et
                conservons vos données. Veuillez prendre le temps de vous
                familiariser avec nos pratiques en matière de protection des
                données à caractère personnel et contactez-nous si vous avez des
                questions.
                <h2>
                  Collecte et utilisation des données à caractère personnel
                </h2>
                Les données personnelles (ou « informations personnelles ») sont
                des données qui peuvent être utilisées pour identifier de
                manière unique ou contacter une seule personne.
                <h2>
                  Collecte et utilisation des données à caractère non-
                  Divulgation à des tiers
                </h2>
                Aucune donnée n’est divulguée a des tiers.
                <h2>Protection des données à caractère personnels</h2>
                Le Baravin1755 prend des précautions – y compris des mesures
                administratives, techniques et physiques – pour protéger vos
                données personnelles contre la perte, le vol et la mauvaise
                utilisation, ainsi que l’accès, la divulgation, l’altération et
                la destruction non autorisés.
                <h2>
                  Intégrité et conservation des données à caractère personnel
                </h2>
                Vos données ne sont pas conservées, dés que votre réservation
                est traitée (que vous recevez le mail de confirmation), vos
                données sont effacées de nos serveurs de façon programmatique.
                <h2>Questions sur la confidentialité</h2>
                Si vous avez des questions ou des inquiétudes concernant le
                traitement de vos données ou l’Engagement de confidentialité
                d’Apple, contactez-nous.
              </Container>
            </Route>
          </Switch>
          <Divider />
          <Copyright />
        </CategoriesSidebar>
      </>
    </div>
  );
};

export default App;
